module.exports = __webpack_public_path__ + "img/ch48.8ecfd3bf.jpg";